import ServiceBus from "servicestack/service-bus";

export default class QueryProviderController {
    constructor() {
	   this.bus = new ServiceBus();
    }

    $onChanges = ({ url }) => {
	   if (url && url.currentValue) {
		  this.bus.read(url.currentValue)
			 .then(({ data }) => Object.assign(this, data));
	   }
    }
};
